"use strict";

const html = document.querySelector('html');

const elements = {
    boxes: document.querySelectorAll('.box:not(.header-image) > *:not(ul), .box:not(.header-image) > ul > li'),
    gallery: document.querySelectorAll('.gallery-group > h2, .gallery > figure'),
    teaser: document.querySelectorAll('.teaser')
};

html.classList.remove('no-js');
html.classList.add('js');

let options = {
    rootMargin: '0px',
};

window.fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            window.fadeInObserver.unobserve(entry.target);
        }
    });
}, options);

for (const element of Object.values(elements)) {
    if (element.length !== 0) {
        element.forEach((item) => {
            item.classList.add('animated');
            window.fadeInObserver.observe(item);
        });
    }
}
